import script from "./NoSearchResults.vue?vue&type=script&setup=true&lang=js"
export * from "./NoSearchResults.vue?vue&type=script&setup=true&lang=js"

import "./NoSearchResults.vue?vue&type=style&index=0&id=89d4d3e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d4d3e8"]])

export default __exports__